import { makeAutoObservable } from 'mobx';

import { ProviderUid } from '@gem/call/CallProviders/callProviders.types';

import { Members } from './Members';

export class HandsQueue {
  private members: Members;

  constructor(members: Members) {
    this.members = members;

    makeAutoObservable(this);
  }

  private get _list(): ProviderUid[] {
    const arr: { uid: ProviderUid; ts: number }[] = [];

    for (const memberDevice of this.members.memberDevicesList) {
      if (memberDevice.isHandRaised && memberDevice.handRaisedAt != null && memberDevice.uid) {
        arr.push({ uid: memberDevice.uid, ts: memberDevice.handRaisedAt });
      }
    }

    arr.sort((a, b) => a.ts - b.ts);
    return arr.map((x) => x.uid);
  }

  get size(): number {
    return this._list.length;
  }

  getPosition(uid: ProviderUid | null): number | null {
    if (!uid) return null;
    const i = this._list.indexOf(uid);
    return i === -1 ? null : i + 1;
  }

  get isShowPosition(): boolean {
    return this.size >= 1;
  }
}
